import {
  ClockStationService,
  ClocksService,
  ControlBlock_SetCoordinatesMode,
  ControlBlock_SetSunSetRaiseCorrectionMode,
  ControlBlocksService,
  SetEspTimeSyncSourceModel,
  StandardTimeModel,
  StandardTimeOffsetModel,
  StateModel,
} from "../api";
import {
  mapEspSynchronizationSource,
  mapTimeValue,
} from "../shared/Helpers.utils";

const systemDataCache = new Map<string, Promise<any>>();

const getSystemDataRequest = async (id: string): Promise<any> => {
  const cacheKey = String(id);

  if (systemDataCache.has(cacheKey)) {
    return systemDataCache.get(cacheKey);
  }

  const request = ControlBlocksService.getApiControlBlocksSystemData(id)
    .catch((error) => {
      systemDataCache.delete(cacheKey);
      throw error;
    });

  systemDataCache.set(cacheKey, request);
  return request;
};

const clearSystemDataCache = (id: string) => {
  systemDataCache.delete(String(id));
};

export const PrimaryClockApi = {

  // Получение времени
  getTime: async (id: string) => {
    return ClockStationService.getApiClockStationTime(id);
  },

  // Обновление времени
  updateTime: async (id: string, time: string | Date): Promise<boolean> => {
    const payload: StandardTimeModel = {
      time: mapTimeValue(time),
    };

    await ClockStationService.postApiClockStationTime(id, payload);
    return true;
  },

  // Обновление часового пояса
  updateTimezone: async (id: string, offset: string): Promise<boolean> => {
    const payload = {
      offset,
    } as unknown as StandardTimeOffsetModel;

    await ClockStationService.postApiClockStationTimeTimezone(id, payload);
    return true;
  },

  // Получение координат
  getCoordinates: async (id: string): Promise<any> => {
    return getSystemDataRequest(id);
  },

  // Получение системных данных ESP
  getSystemData: async (id: string, options?: {force?: boolean}): Promise<any> => {
    if (options?.force) {
      clearSystemDataCache(id);
    }

    return getSystemDataRequest(id);
  },

  // Обновление координат
  updateCoordinates: async (id: string, coordinates: {lat: number; lon: number}): Promise<boolean> => {
    const payload: ControlBlock_SetCoordinatesMode = {
      lat: coordinates.lat,
      lon: coordinates.lon,
    };

    await ControlBlocksService.postApiControlBlocksCoordinates(id, payload);
    clearSystemDataCache(id);
    return true;
  },

  // перерасчет координат
  recalculationCoordinates: async (id: string): Promise<boolean> => {
    await ControlBlocksService.postApiControlBlocksBlank(id);
    clearSystemDataCache(id);
    return true;
  },

  updateSunsetCorrection: async (id: string, correction: number): Promise<boolean> => {
    const payload: ControlBlock_SetSunSetRaiseCorrectionMode = {correction};
    await ControlBlocksService.postApiControlBlocksCorrectionSunset(id, payload);
    clearSystemDataCache(id);
    return true;
  },

  updateSunraiseCorrection: async (id: string, correction: number): Promise<boolean> => {
    const payload: ControlBlock_SetSunSetRaiseCorrectionMode = {correction};
    await ControlBlocksService.postApiControlBlocksCorrectionSunraise(id, payload);
    clearSystemDataCache(id);
    return true;
  },

  updateLedState: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ControlBlocksService.postApiControlBlocksLedState(id, payload);
    clearSystemDataCache(id);
    return true;
  },

  // получение даты и времени ntp сервера
  getNtpTime: async (id: string) => {
    return ControlBlocksService.getApiControlBlocksTimeNtp(id);
  },

  // получение данных синхронизации
  getSyncParams: async (id: string) => {
    const response = await ClocksService.getApiClocksSynchronization(id);

    return {
      ...response,
      ntpSyncEnabled: Boolean(response.ntpSyncEnabled),
      gpsSyncEnabled: Boolean(response.gpsSyncEnabled),
    };
  },

  // получение тайм зоны
  getTimezone: async (id: string) => {
    return ClockStationService.getApiClockStationTimeTimezone(id);
  },


  //синхронизация времени
  synchronizeTime: async (id: string, synchronizationSource: number | string): Promise<boolean> => {
    const payload: SetEspTimeSyncSourceModel = {
      synchronizationSource: mapEspSynchronizationSource(synchronizationSource),
    };

    await ControlBlocksService.postApiControlBlocksTimeSynchronize(id, payload);
    return true;
  },

  //Обновление названия альт. Сервера
  updateAltNtpServer: async (id: string, server: string) => {
    await ClocksService.postApiClocksSynchronizationNtpAlternative(id, {server});
    return true;
  },


}
